const SelectFilesEntry = ({ handleFileUpload, validateState, files }) => {
  return (
    <div className="w-full flex flex-col justify-center items-center">
      <input type="file" hidden id="browse" onChange={handleFileUpload} multiple />
      <label
        htmlFor="browse"
        className="
        w-20 h-20 bg-minima-orange-2023 text-black flex items-center justify-center rounded-full font-medium text-[80px] cursor-pointer
        hover:bg-minima-orange-light hover:transition-all duration-600 ease-linear
        "
      >
        +
      </label>
      <div className="flex flex-col items-center text-center">
        <p className="mt-3 text-[18px] font-medium">Drag and drop file</p>
        <p className="text-[14px] text-core-grey-80 font-medium">Or select a file</p>
      </div>
    </div>
  );
};
export default SelectFilesEntry;
